<template>
  <component :is="currentView" :active="active"></component>
</template>

<script>
import eq from 'lodash/eq';
import { mapGetters } from 'vuex';
import WConfigCommonGroup from './common';
import WConfigDatabaseGroup from './database';
import WConfigE2eGroup from './e2e';
import WConfigNetdeviceGroup from './netdevice';
import WConfigNetinterfaceGroup from './netinterface';
import WConfigSensorGroup from './sensor';
import WConfigServerGroup from './server';
import WConfigServiceGroup from './service';
import WConfigVirtualGroup from './virtual';
import WConfigApmGroup from './apm';
import WConfigWirelessGroup from './wireless';

export default {
  name: 'WConfigGroup',
  components: {
    WConfigCommonGroup,
    WConfigDatabaseGroup,
    WConfigE2eGroup,
    WConfigNetdeviceGroup,
    WConfigNetinterfaceGroup,
    WConfigWirelessGroup,
    WConfigSensorGroup,
    WConfigServerGroup,
    WConfigServiceGroup,
    WConfigVirtualGroup,
    WConfigApmGroup,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedObjDefineIds', 'selectedNode']),
  watch: {
    selectedObjDefineIds: {
      handler(selectedList) {
        this.changeView(selectedList);
      },
      immediate: true,
    },
    active: {
      handler() {
        this.changeView(this.selectedObjDefineIds);
      },
    },
  },
  methods: {
    /**
     * 상단 장비목록의 선택 장비가 변경될 경우 화면을 변경하기 위한 함수
     * @author kimjy
     * @param  {Array} selectedList 선택된 장비의 objDefineId 리스트
     */
    changeView(selectedList) {
      /*
        - 선택된 장비가 하나일 경우 해당 장비의 화면 출력
        - 선택된 장비가 없거나 하나 이상일 경우 공통 화면 출력
       */
      if (this.active) {
        // Root 레벨 - objtypebar에서는 인터페이스를 제공하지 않는다. Root로 이동할 때 인터페이스는 선택항목에서 제외시킨다.
        if (this.selectedNode.type === 'root' && selectedList.length > 0 && (selectedList.includes('NETINTERFACE'))) {
          selectedList.splice(selectedList.indexOf('NETINTERFACE'), 1);
        }
        if (selectedList.length === 1) {
          const objDefineId = selectedList[0];
          if (eq(objDefineId, 'SERVER')) {
            this.currentView = WConfigServerGroup.name;
          } else if (eq(objDefineId, 'NETDEVICE')) {
            this.currentView = WConfigNetdeviceGroup.name;
          } else if (eq(objDefineId, 'NETINTERFACE')) {
            this.currentView = WConfigNetinterfaceGroup.name;
          } else if (eq(objDefineId, 'WIRELESS_DEVICE')) {
            this.currentView = WConfigWirelessGroup.name;
          } else if (eq(objDefineId, 'DBMS')) {
            this.currentView = WConfigDatabaseGroup.name;
          } else if (eq(objDefineId, 'E2E_SERVICE')) {
            this.currentView = WConfigE2eGroup.name;
          } else if (eq(objDefineId, 'FMS_SENSOR')) {
            this.currentView = WConfigSensorGroup.name;
          } else if (eq(objDefineId, 'SERVICE')) {
            this.currentView = WConfigServiceGroup.name;
          } else if (eq(objDefineId, 'VMS_OBJECT')) {
            this.currentView = WConfigVirtualGroup.name;
          } else if (eq(objDefineId, 'WAS')) {
            this.currentView = WConfigApmGroup.name;
          }
        } else if (selectedList.length === 2) {
          let isContainWireless = false;
          let isContainNd = false;
          selectedList.forEach((item) => {
            if (eq(item, 'WIRELESS_DEVICE')) {
              isContainWireless = true;
            } else if (eq(item, 'NETDEVICE')) {
              isContainNd = true;
            }
          });
          // 네트워크 장비 + 무선 장비 모두가 선택된 경우
          if (isContainNd && isContainWireless) {
            this.currentView = WConfigNetdeviceGroup.name;
          } else {
            this.currentView = WConfigCommonGroup.name;
          }
        } else {
          this.currentView = WConfigCommonGroup.name;
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/index.vue